import Component from './container/MealContainer'

export default Component
